// extracted by mini-css-extract-plugin
module.exports = {"viewCheckout":"Add-Jtails_viewCheckout_sSoyJ","sectionStep":"Add-Jtails_sectionStep_rEsJt","infoBoxMobile":"Add-Jtails_infoBoxMobile_3RWHm"};